import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n	flex-basis: 50%;\n	display: flex;\n	height: 100px;\n	margin: 12px 0;\n	width: 100%;\n	max-width: 336px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	width: 24px;\n	margin-right: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ResponsiveText } from "~/components/Marketing";
var Wrap = styled.div.withConfig({
    componentId: "sc-565e1919-0"
})(_templateObject());
var IconWrap = styled.div.withConfig({
    componentId: "sc-565e1919-1"
})(_templateObject1());
var TextWrap = styled.div.withConfig({
    componentId: "sc-565e1919-2"
})(_templateObject2());
var StreamYardForCard = function(param) {
    var body = param.body, header = param.header, icon = param.icon;
    return /*#__PURE__*/ _jsxs(Wrap, {
        children: [
            /*#__PURE__*/ _jsx(IconWrap, {
                children: icon
            }),
            /*#__PURE__*/ _jsxs(TextWrap, {
                children: [
                    /*#__PURE__*/ _jsx(ResponsiveText, {
                        component: "h2",
                        variant: "h5",
                        children: header
                    }),
                    /*#__PURE__*/ _jsx(ResponsiveText, {
                        variant: "body",
                        children: body
                    })
                ]
            })
        ]
    });
};
StreamYardForCard.propTypes = {
    body: PropTypes.node.isRequired,
    header: PropTypes.node.isRequired,
    icon: PropTypes.node.isRequired
};
export default StreamYardForCard;
